import {IAppRoute} from "../../application/config/IAppRoute";

import {routeAlertMgtmListPage} from "./routeAlertMgtmListPage";
import {routeAlertMgtmSettingsPage} from "./routeAlertMgtmSettingsPage";
import {routeAlertMgtmTestPage} from "./routeAlertMgtmTestPage";

export const routesAlertsManagement: IAppRoute<any>[] = [
  routeAlertMgtmListPage,
  routeAlertMgtmSettingsPage,
  routeAlertMgtmTestPage,
];
